export const COMPANY = {
  brand: "Plan-Sarthi",
  legalName: "Sarthi Associates",
  email: "admin@plansarthi.com",
  city: "Ghazipur",
  state: "Uttar Pradesh",
  country: "India",
  address: "Ghazipur, Uttar Pradesh, India",
  jurisdiction: "Ghazipur, Uttar Pradesh, India",
  site: "https://plansarthi.com",
  effective: "1 June 2026",
};
